<template>
  <div v-if="!blockTraditionalTransfer" class="payment-method"
    :class="{'payment-method--not-selected': !selected && !initialAvailable}">
    <div class="payment-method__clickable" @click="$emit('click')" />
    <div class="payment-method__header">
      <div class="payment-method__header--radio" :class="{'selected': selected}" />
      <p class="payment-method__header--name" v-html="name" />
      <img v-if="isBankSelection" src="assets/images/icons_payments/logo_1000.png">
    </div>
    <p class="payment-method__description" v-html="description"/>
    <div v-if="isBankSelection && selected && isMobile" class="payment-method__details">
      <SelectBox v-if="options" icon="v" label="Twój Bank" class="selection-box--blue-border"
        @input="input" name="bankOption" key="bankOption"
        v-model="bankOption" :options="bankOptionsForMobile" />
      <p class="payment-method__description">Jeżeli nie znajdziesz swojego banku na liscie to wybierz sposób płatności "PRZELEW BANKOWY", wówczas otrzymasz emailem wszystkie dane niezbędne do dokonania płatności samodzielnie.</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import SelectBox from '@/components/search/SelectBox'
import MediaDetector from '@/utils/MediaDetector'

const EMPTY_LIST_ITEM = { value: '', text: 'test' }

@Component({
  mixins: [
    MediaDetector,
  ],
  components: {
    SelectBox,
  },
  props: {
    name: {
      type: String,
      required: true,
      default: '',
    },
    description: {
      type: String,
      required: true,
      default: '',
    },
    details: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array,
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
      default: () => false,
    },
    initialAvailable: {
      type: Boolean,
      required: true,
    },
    uiActionId: {
      type: String,
      required: false,
    },
    paymentTypeId: {
      type: Number,
      required: false,
    },
    isTraditionalTransferBlocked: {
      type: Boolean,
      required: false,
    },
    onClick: {
      type: Function,
      required: false,
    },
  },
  computed: {
    blockTraditionalTransfer () {
      return this.paymentTypeId == 2000 && this.isTraditionalTransferBlocked
    },
  },
})
export default class PaymentMethod extends Vue {
  items = this.options ? [ EMPTY_LIST_ITEM, ...this.options ] : []
  bankOption = ''

  get bankOptionsForMobile () {
    return this.items.map(item => ({ value: item.PaymentTypeId, text: this.formatListItem(item, 'Wybierz z listy Twój Bank') }))
  }

  get isBankSelection () {
    return this.uiActionId == 'select-bank'
  }

  formatListItem (item, defaultText = '') {
    if (item.value === EMPTY_LIST_ITEM.value) return defaultText
    else return `${item.Name}`
  }

  input () {
    this.$emit('input', this.bankOption)
    this.onClick && this.onClick()
  }
}
</script>

<style lang="scss" scoped>
.payment-method {
  background: #FFF;
  width: 100%;
  min-height: 80px;
  padding: 14px 22px 30px;
  margin-bottom: 10px;
  cursor: pointer;
  position: relative;
  outline: none;

  @include mediaFluid(tablet) {
    width: 32%;
    height: 200px;
    padding: 22px 16px;
    margin-bottom: 0px;
  }

  @include mediaFluid(desktop) {
    width: 190px;
    height: 180px;
    float: left;
    margin-right: 20px;
    padding-left: 18px;

    &:hover {
      box-shadow: 0px 0px 4px 1px rgba(#000000, .15)
    }
  }

  &__clickable {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
  }

  &__header {
    display: flex;
    align-items: baseline;
    margin-bottom: 5px;
    position: relative;

    @include mediaFluid(tablet) {
      width: 50%;
      flex-direction: column;
    }

    &--radio {
      position: relative;
      width: 12px;
      height: 12px;
      border: 2px solid #FFF;
      border-radius: 50%;
      box-shadow: 0px 0px 0px 2px #005CA9;

      @include mediaFluid(tablet) {
        margin-left: 4px;
      }

      &::after {
        position: absolute;
        content: '';
        width: 12px;
        height: 12px;
        left: -4px;
        top: -4px;
        background: transparent;
        border: 2px solid #005CA9;
        border-radius: 50%;
      }
    }

    &--name {
      font-size: 21px;
      font-weight: bold;
      line-height: 22px;
      color: #005CA9;
      text-transform: uppercase;
      padding-left: 10px;

      @include mediaFluid(tablet) {
        padding-top: 16px;
        padding-bottom: 20px;
        padding-left: 0px;
        font-size: 20px;
      }
    }

    .selected {
      background: #005CA9;
    }

    img {
      max-width: 75px;
      position: absolute;
      top: 40px;
      left: 205px;

      @include mediaFluid(tablet) {
        left: 88px;
        top: auto;
        bottom: 22px;
      }
    }
  }

  &__description {
    font-size: 13px;
    font-weight: 100;
    line-height: 1.2em;
    max-width: 230px;

    @include mediaFluid(tablet) {
      padding-right: unset;
      max-width: none;
    }

    @include mediaFluid(desktop) {
      line-height: 1.3em;
    }
  }

  &__details {
    display: flex;
    flex-direction: column;

    p {
      max-width: none;
    }
  }

  &--not-selected {
    opacity: .5;
  }
}
</style>

<style lang="scss">
.booking-payment .selection-box {
  margin-top: 22px;
  margin-bottom: 20px;
  color: #005CA9;
  z-index: 1;

  &__label {
    font-size: 11px;
  }

  &__icon {
    margin-top: 14px;
  }

  select {
    color: #005CA9;
    text-transform: none;
    font-size: 13px;
    padding: 8px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/booking/PaymentMethod.vue